import axios from "axios";

const logout = () => {
  localStorage.removeItem("green_login");
  localStorage.removeItem("phone");
  localStorage.removeItem("green_token");
  localStorage.removeItem("kyc");
};

const defaultOptions = {
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    "System-Key": process.env.REACT_APP_SYSTEM_KEY,
  },
};

const instance = axios.create(defaultOptions);


instance.interceptors.request.use(function (config) {
  // Value the backend expects; falls back to env override if provided.
  config.headers["System-Key"] = process.env.REACT_APP_SYSTEM_KEY || "Green-heap-gold";

  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (
      response.status === 401 ||
      response.status === 403 ||
      response.data?.status === 403
    ) {
      logout();
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;


